import { createContext } from 'react';

import type { TPaymentCheckoutContextValue } from '../types/payment-session.types';

export const PaymentCheckoutContext = createContext<TPaymentCheckoutContextValue | null>(null);
